/**
 * Schritt 1 des Workload-Steckbriefs (NC-1279): Zweck und Nutzen.
 */

import React from 'react';
import { Box, MenuItem, TextField, Typography } from '@mui/material';
import { WorkloadProfileInput, ProfileAudienceScope } from '../../../services/types';
import { ProfileStepProps } from './types';

const SCOPES: { v: ProfileAudienceScope; label: string }[] = [
  { v: 'intern', label: 'Interne Mitarbeiter' },
  { v: 'extern', label: 'Externe Teilnehmer' },
  { v: 'gemischt', label: 'Gemischt' },
];

export default function ProfileStepPurpose({ value, onChange }: ProfileStepProps) {
  const set = (patch: Partial<WorkloadProfileInput['purpose']>) =>
    onChange({ ...value, purpose: { ...value.purpose, ...patch } });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h6">Zweck &amp; Nutzen</Typography>

      <TextField
        label="Ziel — was soll erreicht werden?"
        helperText="Was sollen Teilnehmer danach können? 2–4 Sätze."
        multiline minRows={3} fullWidth
        value={value.purpose.goal}
        onChange={(e) => set({ goal: e.target.value })}
      />

      <TextField
        label="Zielgruppe"
        helperText="Welche Rolle oder Abteilung wird geschult?"
        fullWidth
        value={value.purpose.audience}
        onChange={(e) => set({ audience: e.target.value })}
      />

      <TextField
        select label="Teilnehmerkreis" fullWidth
        value={value.purpose.audienceScope}
        onChange={(e) => set({ audienceScope: e.target.value as ProfileAudienceScope })}
      >
        {SCOPES.map((s) => <MenuItem key={s.v} value={s.v}>{s.label}</MenuItem>)}
      </TextField>

      <TextField
        label="Alternative ohne diesen Workload"
        helperText="Wie liefe die Schulung sonst? Diese Angabe stützt später die Entscheidung, ob sich der Workload lohnt."
        multiline minRows={2} fullWidth
        value={value.purpose.alternative}
        onChange={(e) => set({ alternative: e.target.value })}
      />
    </Box>
  );
}
